export default __webpack_public_path__ + "static/media/army_72.7bb6ffa8.jpg";